import { createNavigation } from "next-intl/navigation";

import { routing } from "./routing";

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration.
// Kept out of ./routing so the middleware (proxy.ts) doesn't transitively
// bundle the request config (which uses next/root-params).
export const { Link, getPathname, redirect, usePathname, useRouter } =
  createNavigation(routing);
